import { mergeObjectEntities } from "src/shared/initializers/typePolicies/helpers/mergeObjectEntities"

export const firmClient = {
  FirmClientList: {
    fields: {
      entities: {
        merge: mergeObjectEntities,
      },
    },
  },
}
